<template>
  <div class="checkbox">
    <label :for="id" class="checkbox-label">
    <input type="checkbox" class="checkbox-input" :required="required" :class="{'checkbox-input_disabled': disabled}" :name="name" :id="id" :disabled="disabled" :checked="value" :value="val" @change="$emit('input', !value)">
      <span class="check"></span>
      <div class="checkbox-text"><slot></slot></div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    value: {
      type: [Boolean, Array],
    },
    val: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-input {
  display: none;
  &:checked + span {
    background-position: center;
    &:after {
      left: 100%;
    }
  }
  &_disabled {
    & + span {
      border-color: $grey-color7;
      cursor: not-allowed;
      & + .checkbox-text {
        color: $grey-color2;
      }
    }
  }
}

.check {
  $width: 24px;
  display: inline-block;
  vertical-align: middle;
  width: $width;
  height: 24px;
  border: 2px solid $red-color3;
  border-radius: 3px;
  background: url("~src/assets/svg/uncheck.svg") no-repeat;
  background-position: $width 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:after {
    content: '';
    background: $white-color2;
    position: absolute;
    width: 40px;
    height: 20px;
    left: -100%;
    top: 0;
    transition: $transition*2;
  }
}

.checkbox-label {
  user-select: none;
}

.checkbox-text {
  font-size: 13px;
  margin-left: 9px;
  display: inline-block;
  user-select: none;
  font-weight: 500;
  position: relative;
  top: 1px;
  a {
    text-decoration: none;
    @include font(13px, $red-color3);
    font-weight: 500;
  }
}

.delete-account-modal__checkbox {
  .checkbox-text {
    font-weight: normal;
    margin-left: 12px;
  }
}
.login__checkbox {
  .checkbox-label {
    cursor: pointer;
  }
}

.settings__checkbox {
  @include mobileStyles {
    .checkbox-text {
      max-width: 200px;
      position: relative;
      top: 8px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/CheckboxEl.vue